import { createFileRoute } from '@tanstack/react-router';
import { ExpenseHub } from '@/features/expense/ExpenseHub';

/**
 * Nota spese mensile — `expense-reports` (BE v1.121.1, EXPENSE-REIMBURSEMENT §D).
 *
 * Spenta di default sul tenant (`timesheet-policy.expenseReportEnabled`): la pagina esiste
 * comunque e dichiara di essere disattivata, invece di sparire dal menu — un modulo che non
 * si vede è un modulo che nessuno sa di poter accendere.
 */
export const Route = createFileRoute('/_app/expense-reports')({ component: ExpenseHub });
